import { IconClose } from "@/assets/icons/geist/IconClose";
import { cn } from "@/components/podkit/lib/cn";
import { Tooltip } from "@/components/Tooltip";
import { type FC } from "react";

type DomainPillProps = {
    domain: string;
    verified?: boolean;
    onRemove?: () => void;
    disabled?: boolean;
    className?: string;
};

export const DomainPill: FC<DomainPillProps> = ({ domain, verified = true, onRemove, disabled = false, className }) => {
    const pill = (
        <span
            className={cn(
                "inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-sm",
                verified
                    ? "border-content-brand/30 bg-content-brand/10 text-content-brand"
                    : "border-content-secondary/30 bg-content-secondary/10 text-content-secondary",
                className,
            )}
        >
            <span className="truncate">{domain}</span>
            {onRemove && (
                <button
                    type="button"
                    onClick={onRemove}
                    disabled={disabled}
                    className={cn(
                        "flex items-center justify-center rounded-full p-0.5",
                        verified ? "hover:bg-content-brand/20" : "hover:bg-content-secondary/20",
                        disabled && "cursor-not-allowed opacity-50",
                    )}
                    aria-label={`Remove ${domain}`}
                    data-testid={`remove-domain-${domain}`}
                    data-tracking-id="remove-domain-pill"
                >
                    <IconClose size="sm" className="size-3" />
                </button>
            )}
        </span>
    );

    if (!verified) {
        return <Tooltip content="This domain is not enabled for this provider. Verify it first.">{pill}</Tooltip>;
    }

    return pill;
};
